<template>
<div class="chapter">
<div class="inner_page">
<img src="Even_Ninjas_Need_To_Wee__Louise_Aaron__v2__EPUB__292192.html.jpg" style="margin-right: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Even_Ninjas_Need_To_Wee__Louise_Aaron__v2__EPUB__292192.vue?d40ffd08